import React from "react";
import PropTypes from "prop-types";

import { Icon } from "semantic-ui-react";

import Tooltip from "components/Tooltip";

import { UpgradeButton } from "scenes/Hubly/components/Workspace/components/UpgradeModal/components";

function MeetingSyncEligibilityTooltip({ eligibility, resourceLink, ctaText }) {
  return (
    <Tooltip
      hoverable
      title={
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "15px",
          }}
        >
          <div data-test="upgrade-message">{eligibility?.cause}</div>
          <div data-test="learn-more">
            Want to learn more about meeting dates sync? Find videos and
            resources{" "}
            <a
              href={
                resourceLink ||
                "https://help.myhubly.com/en/articles/9846358-crm-client-meeting-dates-sync"
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              here
            </a>
            .
          </div>
          <UpgradeButton
            content={ctaText || "Explore Plans"}
            onClick={() => {}}
          />
        </div>
      }
    >
      <Icon
        link
        name="exclamation triangle"
        color="yellow"
        data-test="meeting-dates-sync-tooltip"
      />
    </Tooltip>
  );
}

MeetingSyncEligibilityTooltip.propTypes = {
  eligibility: PropTypes.shape({
    eligible: PropTypes.bool,
    cause: PropTypes.string,
  }),
  resourceLink: PropTypes.string,
  ctaText: PropTypes.string,
};

MeetingSyncEligibilityTooltip.defaultProps = {
  eligibility: {},
  resourceLink: "",
  ctaText: "",
};

export default MeetingSyncEligibilityTooltip;
